<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        lg="4"
        offset-md="7"
      >
        <v-text-field
          v-model="buscaPersonal"
          color="secondary"
          background-color="primary"
          rounded
          filled
          placeholder="Buscar personal por nombre, edad, municipio o estado..."
          append-icon="mdi-magnify"
        />
      </v-col>
      <v-col lg="1">
        <v-btn-toggle
          v-model="ordenAlfabetico"
          class="card"
          rounded
          mandatory
        >
          <v-btn icon>
            <v-icon color="secondary darken-2">
              mdi-order-alphabetical-ascending
            </v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon color="secondary darken-2">
              mdi-order-alphabetical-descending
            </v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="buscaPersonal.length > 0"
        cols="12"
      >
        <div class="text-h6 font-weight-bold">
          {{ filteredDerivaciones.length }}
          resultados encontrados con la búsqueda "{{ buscaPersonal }}"
        </div>
      </v-col>
      <v-col cols="12">
        <v-expansion-panels
          flat
          class="card"
          focusable
          hover
          mandatory
        >
          <v-expansion-panel
            v-for="(grupoDerivacion, index) in groupedDerivaciones"
            :key="index"
          >
            <v-expansion-panel-header>
              <div>
                <div class="text-h6 secondary--text font-weight-bold d-inline">
                  {{ grupoDerivacion.fecha }}
                </div>
                <div class="text-overline d-inline secondary--text">
                  ({{ grupoDerivacion.derivacion.length }})
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <v-row>
                  <v-col
                    v-for="derivacion in grupoDerivacion.derivacion"
                    :key="derivacion.id"
                    cols="12"
                    lg="4"
                    xl="3"
                  >
                    <v-card class="menu-button">
                      <v-card-title>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              <v-avatar
                                rounded
                                color="primary"
                                size="80"
                              >
                                <v-icon
                                  x-large
                                  color="secondary"
                                >
                                  mdi-account
                                </v-icon>
                              </v-avatar>
                            </v-col>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              <div class="text-h6 primary--text font-weight-bold">
                                {{ derivacion.Programacion.Expediente.Personal.apaterno }}
                              </div>
                              <div class="text-subtitle-1 primary--text">
                                {{
                                  derivacion.Programacion.Expediente.Personal.amaterno +
                                    ' ' +
                                    derivacion.Programacion.Expediente.Personal.nombre +
                                    ' ' +
                                    derivacion.Programacion.Expediente.Personal.segundoNombre
                                }}
                              </div>
                              <AltoRiesgoChip v-if="derivacion.idDerivacion % 2 === 0" />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row align="center">
                            <v-col cols="6">
                              <div class="text-caption primary--text">
                                Estatus:
                              </div>
                              <EstatusDerivacionMenuComponent :derivacion="derivacion" />
                            </v-col>
                            <v-col cols="12">
                              <SancionesList />
                            </v-col>
                            <v-col cols="12">
                              <div class="text-caption primary--text">
                                Descripción:
                              </div>
                              <div class="text-body-1 font-weight-bold primary--text">
                                {{ derivacion.oficioSolicitud }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              align="right"
                            >
                              <v-tooltip
                                bottom
                                color="black"
                              >
                                <template #activator="{ on, attrs }">
                                  <v-btn
                                    class="primary secondary--text mx-1"
                                    elevation="8"
                                    icon
                                    :to="{
                                      path:
                                        '/investigacion_socioeconomica/captura_foto/' +
                                        derivacion.Programacion.fk_idExpediente,
                                      params: {
                                        idExpediente: derivacion.Programacion.fk_idExpediente },
                                    }"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon>mdi-camera</v-icon>
                                  </v-btn>
                                </template>
                                <span>Captura de foto</span>
                              </v-tooltip>
                              <v-tooltip
                                bottom
                                color="black"
                              >
                                <template #activator="{ on, attrs }">
                                  <v-btn
                                    class="primary secondary--text mx-1"
                                    elevation="8"
                                    icon
                                    :to="{
                                      path:
                                        '/investigacion_socioeconomica/captura_voz/' +
                                        derivacion.Programacion.fk_idExpediente,
                                      params: {
                                        idExpediente: derivacion.Programacion.fk_idExpediente
                                      },
                                    }"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon>mdi-microphone</v-icon>
                                  </v-btn>
                                </template>
                                <span>Captura de voz</span>
                              </v-tooltip>
                              <v-tooltip
                                bottom
                                color="black"
                              >
                                <template #activator="{ on, attrs }">
                                  <v-btn
                                    class="primary secondary--text mx-1"
                                    elevation="8"
                                    icon
                                    :to="{
                                      path:
                                        '/investigacion_socioeconomica/captura_huella/' +
                                        derivacion.Programacion.fk_idExpediente,
                                      params: {
                                        idExpediente: derivacion.Programacion.fk_idExpediente
                                      },
                                    }"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon>mdi-fingerprint</v-icon>
                                  </v-btn>
                                </template>
                                <span>Captura de huella digital</span>
                              </v-tooltip>
                              <v-tooltip
                                bottom
                                color="black"
                              >
                                <template #activator="{ on, attrs }">
                                  <v-btn
                                    class="primary secondary--text mx-1"
                                    elevation="8"
                                    icon
                                    :to="{
                                      path:
                                        '/investigacion_socioeconomica/captura_firma/' +
                                        derivacion.Programacion.fk_idExpediente,
                                      params: {
                                        idExpediente: derivacion.Programacion.fk_idExpediente
                                      },
                                    }"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon>mdi-draw</v-icon>
                                  </v-btn>
                                </template>
                                <span>Captura de firma digital</span>
                              </v-tooltip>

                              <v-tooltip
                                bottom
                                color="black"
                              >
                                <template #activator="{ on, attrs }">
                                  <v-btn
                                    class="primary secondary--text mx-1"
                                    elevation="8"
                                    icon
                                    v-bind="attrs"
                                    @click="openExpedientePersonalDialog(
                                      derivacion.Programacion.Expediente)"
                                    v-on="on"
                                  >
                                    <v-icon>mdi-file-account</v-icon>
                                  </v-btn>
                                </template>
                                <span>Ver expediente</span>
                              </v-tooltip>
                              <v-tooltip
                                bottom
                                color="black"
                              >
                                <template #activator="{ on, attrs }">
                                  <v-btn
                                    class="primary secondary--text mx-1"
                                    elevation="8"
                                    icon
                                    v-bind="attrs"
                                    @click="openEmisionInformeAntecedentesDialog(derivacion)"
                                    v-on="on"
                                  >
                                    <v-icon>mdi-file-document</v-icon>
                                  </v-btn>
                                </template>
                                <span>Emisión de informe de antecedentes</span>
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <expediente-personal-dialog-component
      :active="expedientePersonalDialog"
      :expediente="selectedExpediente"
      @close="expedientePersonalDialog = false"
    />
    <!-- <actualiza-derivacion-antecedentes-dialog-component
            :active="actualizaDerivacionDialog"
            :derivacion="selectedDerivacion"
            v-on:close="actualizaDerivacionDialog = false"
        ></actualiza-derivacion-antecedentes-dialog-component> -->
    <emision-informe-antecedentes-dialog-component
      :active="emisionInformeAntecedentesDialog"
      :expediente="selectedExpediente"
      :id-derivacion="selectedDerivacion"
      :id-programacion="selectedProgramacion"
      @close="emisionInformeAntecedentesDialog = false"
    />
    <v-overlay
      :value="overlay"
      :z-index="10"
      opacity="1"
      color="secondary"
      align="center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="text-overline mt-4">
        Cargando información. Por favor, espere...
      </div>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import _ from 'lodash';
import ExpedientePersonalDialogComponent from '../../components/expediente/ExpedientePersonalDialogComponent.vue';
import EmisionInformeAntecedentesDialogComponent from '../../components/antecedentes/EmisionInformeAntecedentesDialogComponent.vue';
import EstatusDerivacionMenuComponent from '../../components/EstatusDerivacionMenuComponent.vue';
import SancionesList from '../../components/derivacion/SancionesList.vue';
import AltoRiesgoChip from '../../components/derivacion/AltoRiesgoChip.vue';

export default {
  name: 'AntecedentesView',
  components: {
    ExpedientePersonalDialogComponent,
    EmisionInformeAntecedentesDialogComponent,
    EstatusDerivacionMenuComponent,
    SancionesList,
    AltoRiesgoChip,
  },

  data() {
    return {
      overlay: false,
      buscaPersonal: '',
      ordenAlfabetico: 0,
      expedientePersonalDialog: false,
      selectedExpediente: null,
      actualizaDerivacionDialog: false,
      selectedDerivacion: null,
      emisionInformeAntecedentesDialog: false,
      selectedProgramacion: null,
    };
  },

  computed: {
    ...mapGetters('derivaciones', {
      derivaciones: 'getDerivaciones',
    }),

    filteredDerivaciones() {
      return this.derivaciones.filter((derivacion) => (
        (this.getFullName(derivacion.Programacion.Expediente.Personal)
          .toLowerCase().indexOf(this.buscaPersonal.toLowerCase()) >= 0
          || derivacion.Programacion.Expediente.Personal.rfc.toLowerCase()
            .indexOf(this.buscaPersonal.toLowerCase()) >= 0
          || derivacion.Programacion.Expediente.Personal.curp.toLowerCase()
            .indexOf(this.buscaPersonal.toLowerCase()) >= 0)
          && derivacion.Programacion.fk_idCatEstatusProgramacion !== 4
          && derivacion.Programacion.fk_idCatEstatusProgramacion !== 2
          && derivacion.Programacion.fk_idCatEstatusProgramacion !== 5
      ));
    },

    groupedDerivaciones() {
      const result = _(this.filteredDerivaciones)
        .groupBy((derivacion) => derivacion.fechaOficioSolicitud)
        .map((derivacion, fecha) => ({ fecha, derivacion }))
        .value();

      if (this.ordenAlfabetico === 0) {
        result.sort((a, b) => {
          if (a.fechaOficioSolicitud < b.fechaOficioSolicitud) {
            return -1;
          }
          if (a.fechaOficioSolicitud > b.fechaOficioSolicitud) {
            return 1;
          }
          return 0;
        });
      } else {
        result.sort((a, b) => {
          if (a.fechaOficioSolicitud > b.fechaOficioSolicitud) {
            return -1;
          }
          if (a.fechaOficioSolicitud < b.fechaOficioSolicitud) {
            return 1;
          }
          return 0;
        });
      }
      return result;
    },
  },

  async mounted() {
    this.overlay = true;
    await this.fetchEstatusDerivaciones();
    await this.fetchDerivacionesByArea(21);
    await this.fetchTipoBiometrico();
    this.overlay = false;
  },

  methods: {
    ...mapActions('derivaciones', ['fetchDerivacionesByArea', 'updateEstatusDerivacion']),
    ...mapActions('estatusDerivaciones', ['fetchEstatusDerivaciones']),
    ...mapActions('biometrico', ['fetchTipoBiometrico']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async triggerUpdateDerivacion(derivacion) {
      await this.updateEstatusDerivacion({
        fk_idProgramacion: derivacion.fk_idProgramacion,
        fk_idDerivacion: derivacion.idDerivacion,
      });
      await this.fetchDerivacionesByArea(21);

      this.SET_SNACKBAR_MESSAGE('Evaluación de antecedentes realizada correctamente.');
    },

    ...mapActions('derivaciones', ['fetchDerivacionesByArea']),
    ...mapActions('sexo', ['fetchSexo']),
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('puesto', ['fetchPuestos']),
    ...mapActions('dependencia', ['fetchDependencias']),
    ...mapActions('parentesco', ['fetchParentesco']),
    ...mapActions('areas', ['fetchAreas']),
    ...mapActions('estudio', ['fetchEstudiosByPersonal']),
    ...mapActions('biometrico', ['fetchBiometricosExpediente']),
    ...mapActions('familiares', ['fetchFamiliares']),
    ...mapActions('documento', ['fetchDocumentoByPersonal']),
    ...mapActions('vehiculos', ['fetchVehiculos']),
    ...mapActions('boletasArresto', ['fetchBoletasArresto']),
    ...mapActions('sancionesAdministrativas', ['fetchSancionesAdministrativas']),
    ...mapActions('situacionFinanciera', ['fetchSituacionFinanciera']),
    ...mapActions('datosLaborales', ['fetchDatosLaborales']),
    ...mapActions('evaluacionesMedico', ['fetchEvaluacionesMedicoByExpediente']),
    ...mapActions('evaluacionesPsicologicas', ['fetchEvaluacionesPsicologicasByExpediente']),
    ...mapActions('evaluacionesPoligrafo', ['fetchEvaluacionesPoligrafoByExpediente']),
    ...mapActions('evaluacionesISE', ['fetchEvaluacionesIseByExpediente']),
    ...mapActions('evaluacionesValidacion', ['fetchEvaluacionesValidacionByExpediente']),
    ...mapActions('historiaClinica', ['fetchHistoriasClinicasByExpediente']),
    ...mapActions('programacionEvaluacion', ['fetchProgramacionesEvaluacionesByExpediente']),
    ...mapActions('evaluacionesAntecedentes', ['fetchEvaluacionesAntecedentesByExpediente']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async openExpedientePersonalDialog(expediente) {
      this.loadingExpediente = true;
      this.SET_SNACKBAR_MESSAGE('Cargando información de expediente. Este proceso puede tardar un par de minutos.');
      this.selectedExpediente = expediente;
      await this.fetchEstudiosByPersonal(expediente.Personal.idPersonal);
      await this.fetchBiometricosExpediente(expediente.idExpediente);
      await this.fetchFamiliares(expediente.Personal.idPersonal);
      await this.fetchDocumentoByPersonal(expediente.Personal.idPersonal);
      await this.fetchVehiculos(expediente.Personal.idPersonal);
      await this.fetchBoletasArresto(expediente.Personal.idPersonal);
      await this.fetchSancionesAdministrativas(expediente.Personal.idPersonal);
      await this.fetchSituacionFinanciera(expediente.idExpediente);
      await this.fetchDatosLaborales(expediente.idExpediente);
      await this.fetchEvaluacionesMedicoByExpediente(expediente.idExpediente);
      await this.fetchEvaluacionesPsicologicasByExpediente(expediente.idExpediente);
      await this.fetchEvaluacionesPoligrafoByExpediente(expediente.idExpediente);
      await this.fetchEvaluacionesIseByExpediente(expediente.idExpediente);
      await this.fetchEvaluacionesValidacionByExpediente(expediente.idExpediente);
      await this.fetchProgramacionesEvaluacionesByExpediente(expediente.idExpediente);
      await this.fetchHistoriasClinicasByExpediente(expediente.idExpediente);
      await this.fetchEvaluacionesAntecedentesByExpediente(expediente.idExpediente);

      this.expedientePersonalDialog = true;
      this.loadingExpediente = false;
    },

    async actualizaDerivacion(derivacion) {
      this.selectedDerivacion = derivacion;
      this.actualizaDerivacionDialog = true;
    },

    openEmisionInformeAntecedentesDialog(derivacion) {
      this.selectedExpediente = derivacion.Programacion.Expediente;
      this.selectedDerivacion = derivacion.idDerivacion;
      this.selectedProgramacion = derivacion.fk_idProgramacion;
      this.emisionInformeAntecedentesDialog = true;
    },
  },
};
</script>
